export default __webpack_public_path__ + "static/Roobert-Medium-22485d9fcbd4fdd7667bc76ba5c4339d.woff";